var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-3"},[_c('a',{staticClass:"card-link text-decoration-none",attrs:{"href":"#","title":"Fork"}},[_c('i',{staticClass:"panel-icon fa fa-code-fork"}),_vm._v(" "+_vm._s(_vm.repo.forks))])])}
var staticRenderFns = []

export { render, staticRenderFns }